// extracted by mini-css-extract-plugin
export default {"optionsWrap":"optionsWrap--D7wCj","name":"name--edlpc"};